import { Droppable } from '@hello-pangea/dnd';
import React from 'react';
import { Card, CardBody, CardSubtitle, CardTitle } from 'reactstrap';
import cls from 'classnames';
import LowboyEmployeeAssignment from './LowboyEmployeeAssignment';
import { getNumbersFromEndOfString } from '../utilities/StringHelpers';

export default class LowboyEmployeeCard extends React.Component {
    isValidHover(snapshot, provided) {
        return this.isHover(snapshot) && this.isAllowed(snapshot, provided);
    }

    isInvalidHover(snapshot, provided) {
        return this.isHover(snapshot) && !this.isAllowed(snapshot, provided);
    }

    isHover(snapshot) {
        return snapshot && snapshot.isDraggingOver;
    }

    isAllowed(snapshot, provided) {
        if (!snapshot || !snapshot.draggingOverWith) {
            return false;
        }

        return (
            snapshot.draggingOverWith.startsWith('resource-draggable') ||
            this.isIntraEmployeeAssignmentDrag(snapshot, provided)
        );
    }

    isIntraEmployeeAssignmentDrag(snapshot, provided) {
        const { lowboyEmployee } = this.props;

        const targetEmployeeId = getNumbersFromEndOfString(
            provided.droppableProps['data-rfd-droppable-id']
        );

        if (lowboyEmployee.id != targetEmployeeId) {
            return false;
        }

        const lowboyAssignmentId = getNumbersFromEndOfString(
            snapshot.draggingOverWith
        );

        return lowboyEmployee.lowboyAssignmentIds.includes(lowboyAssignmentId);
    }

    render() {
        const { lowboyEmployee, index } = this.props;

        if (!lowboyEmployee) {
            return null;
        }

        const droppableId = `employee-droppable-${lowboyEmployee.id}`;

        return (
            <Droppable
                key={droppableId}
                droppableId={droppableId}
                index={index}
            >
                {(provided, snapshot) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="employee-card-container"
                        >
                            <Card
                                className={cls(
                                    'employee-card drop-employee-card',
                                    {
                                        'hover-valid': this.isValidHover(
                                            snapshot,
                                            provided
                                        ),
                                        'hover-invalid': this.isInvalidHover(
                                            snapshot,
                                            provided
                                        ),
                                    }
                                )}
                            >
                                <CardBody>
                                    <CardTitle>
                                        {lowboyEmployee.lastName},{' '}
                                        {lowboyEmployee.firstName}
                                    </CardTitle>

                                    <CardSubtitle className="mt-2">
                                        {lowboyEmployee.lowboyAssignmentIds
                                            .length == 0 && (
                                            <>No deliveries scheduled.</>
                                        )}

                                        {lowboyEmployee.lowboyAssignmentIds.map(
                                            (lai, idx) => (
                                                <LowboyEmployeeAssignment
                                                    key={lai.id}
                                                    lowboyAssignmentId={lai}
                                                    lowboyEmployee={
                                                        lowboyEmployee
                                                    }
                                                    idx={idx}
                                                    {...this.props}
                                                />
                                            )
                                        )}
                                    </CardSubtitle>
                                </CardBody>
                            </Card>

                            {provided.placeholder}
                        </div>
                    );
                }}
            </Droppable>
        );
    }
}
